<div class="loader-overlay" *ngIf="loading$ | async">
  <div class="loader-container">

    <div class="road"></div>

    <div class="vehicle">
      🚐
    </div>

    <p class="loading-text">Getting your ride ready...</p>

  </div>
</div>
